import { makeStyles, type DefaultTheme } from '@mui/styles';

type MakeStylesProps = {
  collapsed: boolean;
};

export const useStylesForNavItem = makeStyles<DefaultTheme, MakeStylesProps>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (theme: any): any => ({
    itemLeaf: {
      display: 'flex',
      paddingTop: 0,
      paddingBottom: 0
    },
    buttonLeaf: {
      padding: ({ collapsed }: MakeStylesProps) => '4px 0px',
      justifyContent: 'flex-start',
      textTransform: 'none',
      letterSpacing: 0,
      width: '100%',
      color: 'white',
      borderRadius: '0px',
      minWidth: ({ collapsed }: MakeStylesProps) => !collapsed && '250px',
      fontWeight: 700,
      transition: 'all 250ms ease-in',
      '&.depth-0': {
        fontWeight: 700
      },
      '&:hover': {
        backgroundColor: '#4966e5'
      }
    },
    icon: {
      color: theme.palette.white,
      display: ({ collapsed }: MakeStylesProps) => (collapsed ? 'block' : 'flex'),
      alignItems: 'center',
      marginRight: theme.spacing(1),
      marginLeft: 10,
      transition: 'color 250ms ease-in'
    },
    alignCenter: {
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center'
    },
    active: {
      marginLeft: ({ collapsed }: MakeStylesProps) => (collapsed ? '-12px' : '0px'),
      borderLeft: `8px solid #E0F9FD`,
      backgroundColor: '#4966e5',
      '& $icon': {
        display: ({ collapsed }: MakeStylesProps) => collapsed && 'block',
        marginLeft: ({ collapsed }: MakeStylesProps) => collapsed && 13
      }
    },
    badge: {
      transform: 'scale(1) translate(80%, -60%)',
      whiteSpace: 'nowrap'
    },
    item: {
      maxWidth: 'calc(100% - 30px)'
    }
  })
);
